// @mui material components
import Card from "@mui/material/Card";

// Material Dashboard 3 PRO React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

function Description() {
  return (
    <Card sx={{ width: "100%" }}>
      <MDBox width="95%" textAlign="left" mx="auto" sx={{ mt: 4, ml: 4, mb:2}}>
        <MDBox mb={1}>
        <MDTypography variant="h5" >
          About this Project
        </MDTypography>
        </MDBox>
        <MDTypography variant="body2" color="text">
        This project provides a comprehensive dataset of public sentiment toward solar energy in the United States from 2013 to 2022, using social media data from X (formerly Twitter). For any questions, please contact Serena Kim at North Carolina State University.
        </MDTypography>
      </MDBox>

      <MDBox width="95%" textAlign="left" mx="auto" sx={{ mt: 4, ml: 4, mb: 2 }}>
        <MDBox mb={1}>
          <MDTypography variant="h5">Contributors</MDTypography>
        </MDBox>

        <MDBox display="flex" flexDirection="column" gap={1} sx={{ ml: 2}}>
          <MDTypography variant = "body2" color="text">
            <MDTypography
              variant="body2"
              component="a"
              href="https://chass.ncsu.edu/people/skim235/"
              target="_blank"
              rel="noopener noreferrer"
              sx={{ color: "blue", textDecoration: "none", "&:hover": { textDecoration: "underline" } }}
            >
              Serena Kim
            </MDTypography>
              , NC State University, United States
          </MDTypography>
          
          <MDTypography variant = "body2" color="text">
            <MDTypography
              variant="body2"
              component="a"
              href="https://publicaffairs.ucdenver.edu/people/meet-our-phd-students#ac-crystal-soderman-6"
              target="_blank"
              rel="noopener noreferrer"
              sx={{ color: "blue", textDecoration: "none", "&:hover": { textDecoration: "underline" } }}
            >
              Crystal Soderman
            </MDTypography>
              , University of Colorado at Denver, United States
          </MDTypography>

          <MDTypography variant = "body2" color="text">
            <MDTypography
              variant="body2"
              component="a"
              href="https://www.colorado.edu/business/lan-sang"
              target="_blank"
              rel="noopener noreferrer"
              sx={{ color: "blue", textDecoration: "none", "&:hover": { textDecoration: "underline" } }}
            >
              Lan Sang
            </MDTypography>
              , University of Colorado at Boulder, United States
          </MDTypography>

          <MDTypography variant = "body2" color="text">
            <MDTypography
              variant="body2"
              component="a"
              href="https://www.linkedin.com/in/ethanagodwin/"
              target="_blank"
              rel="noopener noreferrer"
              sx={{ color: "blue", textDecoration: "none", "&:hover": { textDecoration: "underline" } }}
            >
              Ethan Godwin
            </MDTypography>
              , NC State University, United States
          </MDTypography>

          <MDTypography variant = "body2" color="text">
            <MDTypography
              variant="body2"
              component="a"
              href="https://www.linkedin.com/in/koushik-g-760a79159?trk=public_post-text"
              target="_blank"
              rel="noopener noreferrer"
              sx={{ color: "blue", textDecoration: "none", "&:hover": { textDecoration: "underline" } }}
            >
              Koushik Ganesan
            </MDTypography>
              , BestEx Research, United States
          </MDTypography>
        </MDBox>
      </MDBox>

      <MDBox width="95%" textAlign="left" mx="auto" sx={{ mt: 4, ml: 4, mb: 2 }}>
        <MDBox mb={1}>
          <MDTypography variant="h5">Publications</MDTypography>
        </MDBox>
        
        <MDBox component="ul" sx={{ paddingLeft: 3, margin: 0 }}>
          <MDBox component="li">
            <MDTypography variant = "body2" color="text">
            Serena Y. Kim, Crystal Soderman, &amp; Lan Sang.&nbsp;
              <MDTypography
                variant="body2"
                component="a"
                href="https://doi.org/10.1007/s42001-025-00365-z"
                target="_blank"
                rel="noopener noreferrer"
                sx={{ color: "blue", textDecoration: "none", "&:hover": { textDecoration: "underline" } }}
              >
                Sentiment Analysis of Solar Energy in U.S. Cities: A 10-Year Analysis Using Transformer-Based Deep Learning.
              </MDTypography>
              &nbsp; <i>Journal of Computational Social Science.</i>&nbsp;(2025)
            </MDTypography>
          </MDBox>

          <MDBox component="li">
            <MDTypography variant = "body2" color="text">
            Serena Y. Kim, Koushik Ganesan, Princess Dickens, &amp; Soumya Panda.&nbsp;
              <MDTypography
                variant="body2"
                component="a"
                href="https://doi.org/10.3390/su13052673"
                target="_blank"
                rel="noopener noreferrer"
                sx={{ color: "blue", textDecoration: "none", "&:hover": { textDecoration: "underline" } }}
              >
                Public Sentiment toward Solar Energy—Opinion Mining of Twitter Using a Transformer-Based Language Model
              </MDTypography>
              &nbsp; <i>Sustainability.</i>&nbsp;(2021)
            </MDTypography>
          </MDBox>
        </MDBox>
      </MDBox>

      <MDBox width="95%" textAlign="left" mx="auto" sx={{ mt: 4, ml: 4, mb:6}}>
        <MDBox mb={1}>
        <MDTypography variant="h5" >
          Acknowledgements
        </MDTypography>
        </MDBox>
        <MDTypography variant="body2" color="text">
        This work was supported by the University of Colorado Denver’s Infrastructure Informatics Grand Challenge Initiative and the <a style={{ color: "blue", textDecoration: "none" }}  rel="noopener noreferrer"  href="https://www.ucdenver.edu/urban" target="_blank">Presidential Initiative on Urban and Place-Based Research</a>.
        </MDTypography>
      </MDBox>
    </Card>
  );
}

export default Description;
